import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: `20px 20px 0px`,
  },
  centerAlign: {
    alignItems: 'center',
  },
  iconButtonColor: {
    marginLeft: 30,
    color: theme.palette.neutralDark,
  },
  countColor: {
    color: 'white',
  },
  pivotWrapper: {
    padding: '10px 20px',
  },
}));
